<template>
  <CRow>
    <CCol md="12">
      <div class="totals">
        <div class="totals__list d-flex justify-content-center">

          <!-- TOTAL INVITADOS -->
          <div class="totals__item">
            <div class="totals__amount">
              <div class="totals__amount--with-taxes">
                {{ metrics.total }}
              </div>
            </div>
            <div class="totals__info">
              TOTAL INVITADOS
            </div>
          </div>

          <!-- INVITADOS ASIGNADOS -->
          <div class="totals__item">
            <div class="totals__amount">
              <div class="totals__amount--with-taxes">
                {{ metrics.assign }}
              </div>
            </div>
            <div class="totals__info">
              INVITADOS ASIGNADOS
            </div>
          </div>

          <!-- SI REGISTRO EXTERNO -->
          <template v-if="event.external_registration_enabled">

            <div class="totals__item">
              <div class="totals__amount">
                <div class="totals__amount--with-taxes">
                  {{ metrics.attendance }}
                </div>
              </div>
              <div class="totals__info">
                ASISTENCIA
              </div>
            </div>

          </template>

          <!-- SI NO REGISTRO EXTERNO -->
          <template v-else>

            <div class="totals__item">
              <div class="totals__amount">
                <div class="totals__amount--with-taxes">
                  {{ metrics.pending }}
                </div>
              </div>
              <div class="totals__info">
                INVITADOS PENDIENTES
              </div>
            </div>

            <div class="totals__item">
              <div class="totals__amount">
                <div class="totals__amount--with-taxes">
                  {{ metrics.confirm }}
                </div>
              </div>
              <div class="totals__info">
                INVITADOS CONFIRMADOS
              </div>
            </div>

            <div class="totals__item">
              <div class="totals__amount">
                <div class="totals__amount--with-taxes">
                  {{ metrics.incomplete || 0 }}
                </div>
              </div>
              <div class="totals__info">
                CONFIRMACION INCOMPLETA
              </div>
            </div>

          </template>

        </div>
      </div>
    </CCol>
  </CRow>
</template>

<script>
export default {
  name: 'GuestsMetrics',
  props: {
    metrics: {
      type: Object,
      required: true
    },
    event: {
      type: Object,
      required: true
    }
  }
}
</script>

<style scoped>

.totals__item {
  text-align: center;
  margin: 1em 1em 2em;
  padding: 20px;
  box-shadow: 0px 3px 10px rgba(0, 0, 0, 0.11);
}

.totals__amount {
  font-size: 1.5rem;
  color: #2f353b;
  font-weight: bold;
  border-bottom: 2px solid #5C9BD1;
}

.totals__info {
  font-size: 1.1rem;
  color: #AAB5BC;
  font-weight: 600;
  text-transform: uppercase;
}

.totals__amount--with-taxes {
  border-top: 2px solid #5C9BD1;
}
@media (max-width: 767px) {
  /* Totals */
  .totals__list {
    flex-direction: column;
    align-items: center;
  }

  .totals__item {
    width: 100% !important;
    max-width: 280px;
    margin: 0.5rem 0 1rem;
  }
}
</style>
